import React from "react";
import './index.css'

export const AllocationContainer = ({children}) => {
    return (
        <div className="stakes-flex px-4">
            {children}
        </div>
    )
};